import { render, staticRenderFns } from "./ShopManage.vue?vue&type=template&id=0ceda298&scoped=true"
import script from "./ShopManage.vue?vue&type=script&lang=js"
export * from "./ShopManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceda298",
  null
  
)

export default component.exports